import type { TxInternalsType } from 'types/api/internalTransaction';

import { TX_INTERNAL_TYPE_KEY_MAP } from 'ui/tx/i18n';

export type Sort = 'value-asc' | 'value-desc' | 'gas-limit-asc' | 'gas-limit-desc';
export type SortField = 'value' | 'gas-limit';

interface TxInternalsTypeItem {
  title: string;
  titleKey: string;
  id: TxInternalsType;
}

export const TX_INTERNALS_ITEMS: Array<TxInternalsTypeItem> = [
  { title: 'Call', titleKey: TX_INTERNAL_TYPE_KEY_MAP.call, id: 'call' },
  { title: 'Delegate call', titleKey: TX_INTERNAL_TYPE_KEY_MAP.delegatecall, id: 'delegatecall' },
  { title: 'Static call', titleKey: TX_INTERNAL_TYPE_KEY_MAP.staticcall, id: 'staticcall' },
  { title: 'Create', titleKey: TX_INTERNAL_TYPE_KEY_MAP.create, id: 'create' },
  { title: 'Create2', titleKey: TX_INTERNAL_TYPE_KEY_MAP.create2, id: 'create2' },
  { title: 'Self-destruct', titleKey: TX_INTERNAL_TYPE_KEY_MAP.selfdestruct, id: 'selfdestruct' },
  { title: 'Reward', titleKey: TX_INTERNAL_TYPE_KEY_MAP.reward, id: 'reward' },
];
